<template>
  <div>
    <div class="beast-login-warp login">
      <img v-if="showClose" class="close" @click="close" src="https://img.thebeastshop.com/app/4.0/icon/icon-back.png">
      <div class="login-head">
        <p class="title">找回密码</p>
        <p class="tit-phone">{{phoneText}}</p>
      </div>
      <div class="login-main">
        <div class="type" v-show="!stepSmsCode">
          <!-- <div class="item" 
            :class="{active: loginType=='mobile'}"
            @click="changeLoginType('mobile')">手机号</div> -->
          <!-- <div class="item" 
            :class="{active: loginType=='email' }" 
            @click="changeLoginType('email')">邮箱</div> -->
        </div>
        <div class="input-warp">
          <div class="input-group" >
            <div v-show="loginType=='mobile'">
              <template v-if="!stepSmsCode">
                <div class="input-row">
                  <div class="phone-area" @click="selectCountry">
                    {{ country.country_code }}
                  </div>
                  <i class="split"></i>
                  <div class="phone-input">
                    <input type="text" v-model="mobile" placeholder="请输入手机号">
                  </div>
                </div>
                <div class="input-row">
                  <input class placeholder="图片验证码" v-model="captchaCode">
                  <div class="img-code" @click="changeCode">
                    <img :src="captchaCodeSrc"/>
                  </div>
                </div>

                <p class="err-message">{{errmsg}}</p>
                <div @click="validCpatchaCodeSrc" class="login-btn-forget">
                  下一步
                </div>
              </template>
              <template v-else>
                <div class="input-row">
                  <input class placeholder="短信验证码" v-model="mobileCode">
                  <div class="tel-code"
                    :class="{
                      enabled: !smsSended
                    }"
                    @click="validCpatchaCodeSrc">
                    {{ smsSended ? timeDownText : '获取验证码' }}
                  </div>
                </div>
                <div class="input-row">
                  <input class placeholder="设置新密码" v-model="password">
                </div>
                <p class="err-message">{{errmsg}}</p>
                <div @click="resetPass" class="login-btn-forget">
                  下一步
                </div>
              </template>
            </div>
            <div v-show="loginType=='email'">
              <div class="input-row">
                <input type="text" v-model="email" placeholder="请输入邮箱">
              </div>
              <div class="input-row">
                <input class placeholder="图片验证码" v-model="captchaCode">
                <div class="img-code" @click="changeCode">
                  <img :src="captchaCodeSrc"/>
                </div>
              </div>
              <p class="err-message">{{errmsg}}</p>
              <div class="login-btn-forget">
                下一步
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>  
    <forget-success :successShow="successShow" @cancel="success"></forget-success>
  </div>
</template>

<script>
import track from '@/track'
import _country from './data/country.js'
import Vue from 'vue'
import Slide from '@/components/slide'
import BDialog from '@/components/dialog/login-dialog.vue'
import forgetSuccess from './forget-success.vue'
import Select from '@/plugins/select'
import api from './api.js'

let timeDown = null

Vue.use(Select)
export default {
  components:{
    Slide,
    forgetSuccess,
    BDialog
  },
  data (){
    return {
      loginType: 'mobile',
      countryIndex: 0,
      stepSmsCode: false,
      error: '',
      mobile: '',
      email: '',
      codeEnd: 0,
      captchaCode: '',
      mobileCode: '',
      password: '',
      phoneText: '',
      showPassword: false,
      codeTime: new Date().getTime(),
      successShow: false,
      timeDownText: '60秒后获取',
      smsSended: false,
      imgCode: '',
      errmsg: ''
    }
  },
  props: {
    showClose: {
      default: true
    },
    forgetShow: {
      default: false
    }
  },
  computed: {
    country: function(){
      return _country[this.countryIndex]
    },
    phone_code_text: function(){
      return this.codeEnd === 0
        ? '获取验证码'
        : `重新获取(${this.codeEnd})`
    },
    captchaCodeSrc () {
      return `${process.env.AXIOS_BASE_URL}/app/captcha?_timestamp=${this.codeTime}`
    }
  },
  methods: {
    changeCode: function(){
      track({
        name: 'graphicCode'
      })
      this.codeTime = new Date().getTime()
    },

    changeLoginType: function(type){
      track({
        name: `login-${type}`
      })
      this.errmsg = ''
      this.loginType = type
      this.password = ''
      this.captchaCode = ''
      this.mobileCode = ''
      this.changeCode()
    },

    validCpatchaCodeSrc () {
      if (this.smsSended) return
      this.errmsg = ''

      if(this.mobile.length!=11){
        this.errmsg = '请输入正确的手机号'
        return
      }

      if(this.captchaCode == ''){
        this.errmsg = '请输入图形验证码'
        return
      }
      
      api.sms(this.mobile, this.captchaCode, 'RETRIEVE_PASSWORD')
      .then((data) => {

        let personMobile = this.mobile.slice(0, 3) + '*****' + this.mobile.slice(9, 10)

        this.phoneText = `已向${personMobile}发送验证码`
        this.stepSmsCode = true

        this.startTimeDown()
      })
      .catch(({code , message}) => {
        this.errmsg = message
      })
     
    },

    resetPass () {
      this.changePassword()
    },

    sendCode: function(){
      track({
        name: 'verificationCode'
      })
      this.errmsg = ''
      if(this.codeEnd > 0){
        return false
      }
      if(this.mobile.length!=11){
        this.errmsg = '请输入正确的手机号'
        return
      }
      if(this.captchaCode == ''){
        this.errmsg = '请输入图形验证码'
        return
      }
      sa.track('GetCode', {
        service_type: '找回密码'
      })
      api.sms(this.mobile, this.captchaCode)
      .then((data) => {
        this.codeEnd = 60
        this.countDown()
      })
      .catch(({code , message}) => {
        this.errmsg = message
      })
    },
    selectCountry: function(){
      track({
        name: 'areaCode'
      })
      this.$select(_country.map((item) => {
        return item.country_name_cn
      }))
      .then((data) => {
        this.countryIndex = data
      })
      .catch(()=>{
        // console.log('select-cancel');
      })
    },

    startTimeDown () {
      if (timeDown) {
        clearInterval(timeDown)
      }

      let num = 60

      timeDown = setInterval(() => {
        if (num === 0) {
          this.smsSended = false
          clearInterval(timeDown)
          return
        }
        this.smsSended = true

        num--
        this.timeDownText = `${num}秒后获取`
      }, 1000)
    },

    close: function (){
      this.$emit('cancel')
    },
    success: function(){
      this.successShow = false
      this.$emit('forget')
    },
    changePassword: function(){
      this.errmsg = ''
      if(this.mobile.length != 11){
        this.errmsg = '请输入正确的手机号'
        return
      }
      if(this.mobileCode == ''){
        this.errmsg = '请输入短信验证码'
        return
      }
      const password_reg = /^[a-z0-9]{6,16}$/i
      if(!password_reg.test(this.password)){
        this.errmsg = '密码必须为6-16位数字或字母'
        return
      }

      api.modification(this.mobile, this.password, this.mobileCode)
      .then((data) => {
        this.successShow = true
      })
      .catch(({code , message}) => {
        this.errmsg = message
      })
    }
  }
}
</script>

<style lang="stylus">
@import './pass-login.styl'

</style>



// WEBPACK FOOTER //
// forget.vue?54d43006